<template>
  <div>
    <el-dialog
      width="400px"
      :visible="visible"
      @close="closeTask"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>
        <div class="bmType_title">批量业务类型</div>
     </template>
     <el-row type="flex" class="row-bg" align="middle" v-if="incomeShow">
        <el-col :span="4">收入</el-col>
        <el-col :span="20">
            <el-select size="small" v-model="incomeBusinessTypeId" clearable>
                <el-option v-for = "(i,index) in incomeList" :key = "index" :label="i.name" :value="i.id" ></el-option>
            </el-select>
        </el-col>
     </el-row>
     <el-row style="margin-top:20px;" type="flex" class="row-bg" align="middle" v-if="outputShow">
         <el-col :span="4">支出</el-col>
        <el-col :span="20">
            <el-select size="small" v-model="disburseBusinessTypeId" clearable>
                 <el-option v-for = "(i,index) in outputList" :key = "index" :label="i.name" :value="i.id" ></el-option>
            </el-select>
        </el-col>
     </el-row>
      <template #footer>
      <div style="text-align:center">
        <el-button @click="closeTask" size="small" style="width:100px;">取消</el-button>
        <el-button @click="submit" size="small" style="width:100px;background:#269D7B;color:#fff">确定</el-button>
      </div>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import {updateTypes} from '@/api'
export default {
    props:{
        businessTypeList:{
            type:Array,
            default:()=>[]
        }
    },
    watch:{
    },
    data(){
        return {
            incomeShow:true,
            outputShow:true,
            disburseBusinessTypeId:'',
            incomeBusinessTypeId:"",
            incomeList:[],
            outputList:[],
            ids:[],
            visible:false
        }
    },
    methods:{
        submit(){
            let params =  {
                ids:this.ids,
                disburseBusinessTypeId:this.disburseBusinessTypeId,
                incomeBusinessTypeId:this.incomeBusinessTypeId
            }
            updateTypes(params).then(res=>{
                if(res.data.code==1){
                    console.log(res.data)
                    this.$message.success(res.data.msg)
                    this.$emit('refrensh')
                    this.visible = false
                }
            })
            console.log(params)
        },
        openTask(ids,types){
            this.visible = true
            this.ids = ids
            this.incomeShow = (types.length==0||types.indexOf(2)>-1)?true:false  //如果类型为空 或者包含收入类型则显示
            this.outputShow = (types.length==0||types.indexOf(1)>-1)?true:false  //如果类型为空 或者包含支出类型则显示
            this.incomeList = this.businessTypeList.filter(e=>e.type==1)
            this.outputList = this.businessTypeList.filter(e=>e.type==0)
            this.incomeList.unshift({name:'当前业务类型',id:''})
            this.outputList.unshift({name:'当前业务类型',id:''})
        },
        closeTask(){
            this.visible = false
            this.disburseBusinessTypeId = ''
            this.incomeBusinessTypeId = ''
        }
    }
};
</script>

<style lang="less" scoped>
 .bmType_title {
    font-size: 24px;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #333;
 }
</style>


// WEBPACK FOOTER //
// src/components/bankwater/BatchModifyType.vue